import { markSceneBlurred, markSceneTouchedByAgent } from './agent-activity-actions';

import type { AppDispatch } from 'js/src/libs/RootState';

/** Hold scenes under the agent-activity indicator, blurred, for the rest of the turn. */
export function markScenesBusy(dispatch: AppDispatch, sceneIds: string[]): void {
    if (sceneIds.length === 0) {
        return;
    }
    dispatch(markSceneBlurred({ sceneIds }));
    dispatch(markSceneTouchedByAgent({ sceneIds }));
}
